import { ICorrDocumentUpload } from "@api/model/iCorrDocumentUpload";
import { IPDocument } from "../api-generated";
import SDocument from "./sDocument";

export default class CorrDocumentUpload implements ICorrDocumentUpload {
  public ItemId?: string;

  public ReferenceId?: string;

  public Status?: string;

  public FileId?: string;

  public FileType?: string;

  public Guid?: string;

  public Order?: number;

  public DateCreated?: string;

  public DateUpdated?: string;

  public IsArchived?: boolean;

  public Document: IPDocument;

  constructor(
    name: string,
    userId: string,
    fileType: string,
    status: string,
    itemId: string,
    referenceId?: string,
  ) {
    this.Status = status;
    this.FileType = fileType;
    this.ItemId = itemId;
    this.ReferenceId = referenceId;
    this.Document = new SDocument(name, userId);
  }
}
